const e = "_numericCellRoot_42ab7_1", o = {
  numericCellRoot: e
};
export {
  o as default,
  e as numericCellRoot
};
//# sourceMappingURL=index.es5646.js.map
